/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vekn_Sync_ActionInputs */



/**
* | output |
* | --- |
* | "Sync to VEKN" |
*
* @param {Vekn_Sync_ActionInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const vekn_sync_action = /** @type {((inputs?: Vekn_Sync_ActionInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vekn_Sync_ActionInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Synchroniser avec la VEKN")
	if (locale === "es") return /** @type {LocalizedString} */ ("Sincronizar con la VEKN")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Sincronizar com a VEKN")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sincronizza con la VEKN")
	return /** @type {LocalizedString} */ ("Sync to VEKN")
});